import clsx from 'clsx';
import IconProps from '@/app/types/components/IconProps';
import iconsList from '@/app/ui/icons/IconsList';

export default function Icon(props: IconProps) {
  const { name, width, height, viewBox, className } = props;

  const RenderIcon = iconsList[name];
  const calcViewBox = `0 0 ${width} ${height}`;

  return (
    <svg
      className={clsx(className ?? '', {
        'w-full': width === undefined,
        'h-full': height === undefined,
      })}
      width={width}
      height={height}
      viewBox={viewBox ?? calcViewBox}
      fill="none"
    >
      <RenderIcon />
    </svg>
  );
}
